import script from "./newsCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./newsCategory.vue?vue&type=script&setup=true&lang=js"

import "./newsCategory.vue?vue&type=style&index=0&id=75f0c974&scoped=true&lang=css"

import exportComponent from "D:\\project\\安可控\\Dtsc.Official.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75f0c974"]])

export default __exports__